import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { ContextMenuPlugin } from '../context-menu';
import { type IRenderContextMenuItemArgs } from '../type';

export const addImageItem = (_: IRenderContextMenuItemArgs, identity: string) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);
    if (framework.service.edgelessCanvas.isEdgelessMode) return null;

    const item = {
        name: $t((v) => v.contextMenuLayer.upload.addImage),
        type: 'addImage',
        onClick: () => {
            framework.service.registration.getInstance<ContextMenuPlugin>('ContextMenuPlugin').addImage();
        },
    };

    return item;
};
